export default __webpack_public_path__ + "static/media/check_red.1b19455c.svg";